// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 795) return "static/chunks/795.b4b1dc752ed4bc99.js";
	if (chunkId === 563) return "static/chunks/563.c4626d0367e1dfcf.js";
	if (chunkId === 162) return "static/chunks/162.93fdbedbc3cfb7a0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"43":"85350f689832ff17","127":"8081b960486149de","495":"947ee4259496c547","914":"8bace6fbc79e80be"}[chunkId] + ".js";
};